import { CenterModal, ModalSize, PageHeader, SidebarModal, DocumentViewer } from "@repo/design-system/components/ui";
import PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { ViewStudentNotificationPageConfig } from "./config/ViewStudentNotification.config";
import ViewStudentNotificationGrid from "./feature/viewStudentNotificationGrid/ViewStudentNotificationGrid";
import "./ViewStudentNotification.scss";

const ViewStudentNotification = ({ pageSize = 10 }) => {
    const [selectedNotification, setSelectedNotification] = useState(null);
    const [viewImageModal, setViewImageModal] = useState({ isOpen: false, src: "", title: "" });

    const handleView = useCallback((notification) => {
        setSelectedNotification(notification);
    }, []);

    const handleViewImage = useCallback((imageSrc, rowData) => {
        setViewImageModal({
            isOpen: true,
            src: imageSrc,
            title: rowData?.title || "Notification Image",
        });
    }, []);

    const handleCloseImageModal = useCallback(() => {
        setViewImageModal({ isOpen: false, src: "", title: "" });
    }, []);

    return (
        <div className="view-student-notification-page">
            <PageHeader
                title={ViewStudentNotificationPageConfig.title}
                headerIcon={ViewStudentNotificationPageConfig.headerIcon}
                description={ViewStudentNotificationPageConfig.description}
            />

            <section className="view-student-notification-table-card">
                <ViewStudentNotificationGrid
                    onView={handleView}
                    onViewImage={handleViewImage}
                    pageSize={pageSize}
                />
            </section>

            <CenterModal
                isOpen={Boolean(selectedNotification)}
                handleToggleModal={() => setSelectedNotification(null)}
                modalTitle="Notification"
                modelSizeClass={ModalSize.WD50}
                modalClassName="notification-detail-modal"
            >
                {selectedNotification && (
                    <div className="notification-detail-body">
                        <div className="notification-detail-image-frame">
                            {selectedNotification.url ? (
                                <img
                                    src={selectedNotification.url}
                                    alt={selectedNotification.title || "Notification"}
                                    className="notification-detail-image"
                                />
                            ) : (
                                <span className="notification-detail-image-fallback">No image</span>
                            )}
                        </div>
                        <div className="notification-detail-content">
                            <h3>{selectedNotification.title || "-"}</h3>
                            <p>{selectedNotification.description || "-"}</p>
                        </div>
                    </div>
                )}
            </CenterModal>

            <SidebarModal
                modalTitle={viewImageModal.title}
                isOpen={viewImageModal.isOpen}
                onClose={handleCloseImageModal}
            >
                {viewImageModal.src && (
                    <DocumentViewer
                        documentData={{
                            base64Data: viewImageModal.src,
                            file: {
                                name: viewImageModal.title ? `${viewImageModal.title}.png` : "image.png",
                                fileName: viewImageModal.title ? `${viewImageModal.title}.png` : "image.png",
                            },
                        }}
                    />
                )}
            </SidebarModal>
        </div>
    );
};

ViewStudentNotification.propTypes = {
    pageSize: PropTypes.number,
};

export default ViewStudentNotification;
export { ViewStudentNotification };
